<template>
  <div v-if="product.faqsLang.length" class="product-faqs">
    <!-- <pre>{{  filters }}</pre> -->
    <h2 v-if="selectedOptionNameChain">
  {{ $t('fields.faqs') }} :
  {{ selectedOptionNameChain.main }} {{ selectedOptionNameChain.sub }}
</h2>
    <h2 v-else>{{ $t('fields.faqs') }}</h2>
    <p class="product-name">
      {{ product.description.name }}
    </p>
    <div class="faq-items">
      <product-faq v-for="(faq, index) in product.faqsLang" :key="index" :faq="faq" collapsable />
    </div>
  </div>
</template>

<script>
import ProductFaq from './ProductFaq'
export default {
  components: { ProductFaq },
  props: {
    product: {
      type: Object,
      required: true
    },
    filters: {
      type: Array,
      default: () => []
    },
  },
  computed: {
  selectedOptionNameChain() {
    const mainFilter = this.filters.find(f =>
      Array.isArray(f.options) && f.options.some(opt => opt.selected)
    );
    if (!mainFilter) return null;


    const selectedMainOption = mainFilter.options.find(opt => opt.selected);
    if (!selectedMainOption || !selectedMainOption.name) return null;

    const subFilter = this.filters.find(f => f.name === selectedMainOption.name);
    if (!subFilter || !Array.isArray(subFilter.options)) return null;


    const selectedSubOption = subFilter.options.find(opt => opt.selected);
    if (!selectedSubOption || !selectedSubOption.name) return null;

    return {
      main: selectedMainOption.name,
      sub: selectedSubOption.name
    };
  }
}
}
</script>
